import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const getSettings = () => axios.get(`${BASE_URL}/settings`);
export const updateSettings = (data) => axios.put(`${BASE_URL}/settings`, data, authHeader());